var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_494_3695)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19 0H5C2.239 0 0 2.239 0 5V19C0 21.761 2.239 24 5 24H19C21.762 24 24 21.761 24 19V5C24 2.239 21.762 0 19 0ZM14.534 19.59C14.129 19.668 14 19.419 14 19.206V17.011C14 16.264 13.738 15.778 13.45 15.53C15.232 15.332 17.104 14.655 17.104 11.583C17.104 10.709 16.792 9.995 16.281 9.436C16.363 9.234 16.637 8.42 16.202 7.319C16.202 7.319 15.531 7.104 14.004 8.139C13.364 7.959 12.68 7.872 12 7.868C11.32 7.871 10.636 7.959 9.997 8.137C8.469 7.102 7.797 7.317 7.797 7.317C7.363 8.419 7.637 9.232 7.72 9.435C7.208 9.995 6.896 10.708 6.896 11.582C6.896 14.646 8.763 15.333 10.541 15.536C10.312 15.736 10.105 16.088 10.033 16.606C9.576 16.81 8.419 17.163 7.705 15.94C7.705 15.94 7.282 15.172 6.478 15.115C6.478 15.115 5.698 15.105 6.423 15.602C6.423 15.602 6.948 15.848 7.312 16.772C7.312 16.772 7.775 18.2 10 17.716V19.205C10 19.416 9.871 19.664 9.472 19.59C6.292 18.533 4 15.534 4 12C4 7.581 7.582 4 12 4C16.418 4 20 7.581 20 12C20 15.533 17.711 18.531 14.534 19.59Z",
    fill: "#61B766"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_494_3695"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGit);
export default __webpack_public_path__ + "static/media/git.7dfd6788ef96db6b92d743c39ce7273a.svg";
export { ForwardRef as ReactComponent };